/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const ModalSizeWidthSmall = '320px'
export const ModalSizeWidthMedium = '480px'
export const ModalSizeWidthLarge = '640px'
export const ModalSizeWidthXlarge = '800px'
export const ModalSizeWidthXxlarge = '1320px'
export const ModalSpacingContainerVerticalDesktop = '16px'
export const ModalSpacingContainerVerticalMobile = '16px'
export const ModalSpacingHeaderBottomDesktop = '16px'
export const ModalSpacingHeaderBottomMobile = '16px'
export const ModalSpacingContentVerticalDesktop = '8px'
export const ModalSpacingContentVerticalMobile = '8px'
export const ModalColorSurface = '#ffffff'
export const ModalColorOverlay = '#00000014'
export const ModalColorOutline = '#ffffff00'
export const ModalBorderRadiusContainer = '8px'
export const ModalShadowContainerX = '0px'
export const ModalShadowContainerY = '0px'
export const ModalShadowContainerBlur = '24px'
export const ModalShadowContainerSpread = '0px'
export const ModalShadowContainerColor = '#00000026'
export const ModalShadowContainerType = 'dropShadow'
